// extracted by mini-css-extract-plugin
module.exports = {"better_is_possible_container":"index-module__better_is_possible_container___3-eV7"};